<!--
  RiskLevelsFilter renders a filter with dropdown options for risk levels
  and reads/writes from the `risk_levels` URL query param.
-->

<script>
import { iFilter } from '@inscribe/signal';
import { getAndSyncQueryParams, updateQueryParams } from '@/utils/queryParams';
import { RISK_LEVEL, riskLevelToReadableLabel } from '@/constants/riskLevels';

export default {
  components: {
    iFilter,
  },
  data() {
    return {
      params: getAndSyncQueryParams({
        fullPath: this.$route.fullPath,
        router: this.$router,
        store: this.$store,
      }),
      options: Object.values(RISK_LEVEL).map((level) => ({
        label: riskLevelToReadableLabel(level),
        value: level,
      })),
    };
  },
  computed: {
    value() {
      const { risk_levels } = this.params;
      if (!risk_levels) {
        return [];
      }
      let riskLevelsArray =
        typeof risk_levels === 'string' ? [risk_levels] : risk_levels;
      const output = [];
      for (const level of riskLevelsArray) {
        const option = this.options.find((opt) => opt.value === level);
        if (option) {
          output.push(option.label);
        }
      }
      return output;
    },
  },
  watch: {
    '$route.fullPath': {
      handler: function (newFullPath) {
        this.params = getAndSyncQueryParams({
          fullPath: newFullPath,
          router: this.$router,
          store: this.$store,
        });
      },
    },
  },
  methods: {
    onSelectionChanged(updated) {
      const selectedValuesAsParams = updated.selection.map(
        (item) => item.value,
      );

      updateQueryParams({
        fullPath: this.$route.fullPath,
        router: this.$router,
        store: this.$store,
        updates: {
          risk_levels:
            selectedValuesAsParams.length > 0
              ? selectedValuesAsParams
              : undefined,
        },
      });
    },
  },
};
</script>

<template>
  <iFilter
    label="Risk Levels"
    data-dd-action-name="documents-view-risk-levels-filter"
    :options="options"
    :value="value"
    :searchable="false"
    @selection-changed="onSelectionChanged"
  />
</template>
